'use strict';

/**
 * Displays a link to the bestetarief.be website (BIPT) which will compare your priceplan with competitors.
 * For the widget that checks whether you have the best tariff plan from us, check ourBestTariff.
 */
customerZone.component('bestTariff', {
    templateUrl:
        customerZone.fromBase('components/best-tariff/best-tariff.component.html'),
    controllerAs: 'vm',
    controller: ['$log', 'config', 'Session', 'UnleashedClient', function($log, config, session, api){

        var JIMMO_OPERATOR_ID = 'JIO';
        var self = this;

        self.bestTariffLink = undefined;
        self.loading = false;
        self.configured = false;

        var init = function (){
            if (!config.biptBestTariffRoot) return;
            self.configured = true;
            // TODO: after the release of BIPT, log a missing setting to sentry, since this is a legal issue

            self.loading = true;
            api.getUsageTotals(session.subscriber().id, filters())
                .then(function(summary) {
                    self.loading = false;
                    self.bestTariffLink = formatBestTariffUrl(
                        summary.voice.out.duration,
                        summary.data.out.megs,
                        summary.sms.out.count
                    );
                })
                .catch(function(error){
                    $log.error('Failed to load best tariff', error);
                });
        };

        var formatBestTariffUrl = function(voiceMinutes, dataBytes, sms){
            return config.biptBestTariffRoot + '/myusage/?' + jQuery.param({
                svc: 'mo',
                ul: config.language.substr(0, 2),
                op: JIMMO_OPERATOR_ID,
                sms: Math.ceil(sms),
                monat: Math.ceil(voiceMinutes),
                modata: Math.ceil(dataBytes / 1024 / 1024)
            });
        };

        var filters = function() {
            var dateFrom = moment().subtract(30, 'days');
            var dateTo = moment().subtract(1, 'days');
            return {
                regionality: 'national',
                dateFrom: dateFrom,
                dateTo: dateTo
            };
        };

        init();
    }]
});
